import { NgModule } from "@angular/core";
import { NpHljsComponent } from "./np-hljs.component";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        NpHljsComponent
    ],
    exports: [NpHljsComponent],
    providers: []
})
export class NpHljsModule { }